import React, { FC } from 'react';

import loaderDark from 'assets/images/loader_dark.gif';
import loaderLight from 'assets/images/loader_light.gif';
import StyledLoader from './styled';

const Loader: FC<{ size?: number; isDark?: boolean }> = ({ size = 32, isDark = true }) => (
  <StyledLoader size={size} isDark={isDark} style={{ backgroundImage: `url(${isDark ? loaderDark : loaderLight})` }} />
);

export default Loader;
